/* eslint-disable consistent-return,no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { JOIN_TYPES } from '../../../../app/constants/join_types';
import { OPTIMIZATION_TYPES } from '../../../../app/constants/optimization_types';
import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('joinEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./join-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$translate',
        '$compile',
        'ComponentEditorListeners',
        'ngrxStoreService',
        function ($scope, $translate, $compile, ComponentEditorListeners, ngrxStoreService) {
          $scope.form = {};
          $scope.joinTypes = JOIN_TYPES;
          $scope.optimizationTypes = OPTIMIZATION_TYPES;

          $scope.onRecordsChange = (records) => {
            $scope.component.relations = records;
          };

          $scope.onValidityChange = (isValid) => {
            $scope.valid = isValid;
          };

          function checkOptimizationValidity() {
            if (
              $scope.component.optimization_type === 'replicated' &&
              $scope.component.join_type !== 'inner' &&
              $scope.component.join_type !== 'left'
            ) {
              $scope.errorMessage = $translate.instant('join-editor.errors.replicated_optimization_error');
              $scope.isComponentValid(false);
              return {
                isValid: false,
                where: 'join-editor',
                optimization_type: $scope.component.optimization_type,
                join_type: $scope.component.join_type,
              };
            }
            $scope.errorMessage = null;
            $scope.isComponentValid(true);
          }

          $scope.onJoinTypeChange = function (joinType) {
            $scope.component.join_type = joinType;
            checkOptimizationValidity();
            const component = { join_type: joinType };
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.onOptimizationChangeType = function (optimizationType) {
            $scope.component.optimization_type = optimizationType;
            checkOptimizationValidity();
            const component = { optimization_type: optimizationType };
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          const onSaveCallback = function () {
            return checkOptimizationValidity();
          };

          const onSaveSuccessCallback = function () {
            $scope._default.setInputComponentsOrder($scope.components);
          };

          ComponentEditorListeners.onSave(onSaveCallback);

          ComponentEditorListeners.onSaveSuccess(onSaveSuccessCallback);

          $scope.$on('$destroy', function () {
            ComponentEditorListeners.clearOnSaveCb(onSaveCallback);
            ComponentEditorListeners.clearOnSaveSuccessCb(onSaveSuccessCallback);
          });

          $scope.$on(EVENTS.COMPONENTS_ORDER_EDITOR_SWITCH, function (event, components) {
            _.each($scope._records, function (record) {
              const temp = record.input_0;
              record.input_0 = record.input_1;
              record.input_1 = temp;
            });
          });
        },
      ],
    };
  },
]);
